import { useQuery } from "@tanstack/react-query"
import { fetchVisitHistory } from "@/lib/services/fetchVisitHistory"
import type { Visit } from "@/components/custom/appointment-modal/visit-history-section"

/**
 * Custom React Query hook to fetch visit history for a client in a company.
 * @param companyId
 * @param clientId
 */
export function useVisitHistorySection(companyId?: number, clientId?: number) {
  return useQuery<Visit[]>({
    queryKey: ["visitHistorySection", companyId, clientId],
    queryFn: () => fetchVisitHistory(companyId!, clientId!),
    enabled: !!companyId && !!clientId,
    staleTime: 5 * 60 * 1000,
  })
}
